import { TAXES_PAYMENTS_CATEGORY } from '../../checklistCategories';
import type { ApprovalQueueItem } from '../../types';

import type { TaxesPaymentsChecklistRow } from './types';

export function buildTaxesPaymentsQueueItem(row: TaxesPaymentsChecklistRow): ApprovalQueueItem {
  return {
    categoryId: TAXES_PAYMENTS_CATEGORY.id,
    categoryLabel: TAXES_PAYMENTS_CATEGORY.label,
    description: `${row.name} requires review.`,
    details: row.details,
    id: row.id,
    title: row.name,
  };
}

export function getTaxesPaymentsSearchText(row: TaxesPaymentsChecklistRow) {
  return [row.name, row.field, row.statusLabel].filter(Boolean).join(' ');
}
